import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  HomebannerApiRequest,
  UpdateHomebannerRequest,
  DeleteHomebannerRequest,
} from '@/data/payload/api/HomebannerRequest'
import { HomebannerPresenter } from '@/app/ui/presenters/HomebannerPresenter'
import { Homebanner } from '@/domain/entities/Homebanner'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface HomebannerState {
  homebannerData: Homebanner
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'homebanner' })
class Homebanners extends VuexModule implements HomebannerState {
  public homebannerData = new Homebanner(true, '')
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'name', sortable: true },
    { key: 'image', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }

  @Action
  public async getHomebannerData() {
    this.setLoading(true)
    const presenter = await container.resolve(HomebannerPresenter)
    presenter
      .loadHomebanner(this.paginationParam)
      .then((res: Homebanner) => {
        this.setLoading(false)
        this.setHomebannerData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postHomebanner(params: { name: string; imageId: number }) {
    this.setLoading(true)
    const presenter = await container.resolve(HomebannerPresenter)
    presenter
      .postHomebanner(new HomebannerApiRequest(params.name, params.imageId))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Home Banner',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getHomebannerData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateHomebanner(params: {
    id: number
    name: string
    imageId: number
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(HomebannerPresenter)
    presenter
      .updateHomebanner(
        new UpdateHomebannerRequest(params.name, params.imageId),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Home Banner',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getHomebannerData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteHomebanner(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(HomebannerPresenter)
    presenter
      .deleteHomebanner(new DeleteHomebannerRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Home Banner',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getHomebannerData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setHomebannerData(homebanner: Homebanner) {
    this.homebannerData = homebanner
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const HomebannerModule = getModule(Homebanners)
